export function getDocumentScrollTop(): number {
    return getScrollingElement().scrollTop;
}

export function setDocumentScrollTop(scrollTop: number) {
    getScrollingElement().scrollTop = scrollTop;
}

export function setElementScrollTop(element: Element, scrollTop: number) {
    if (element) {
        element.scrollTop = scrollTop;
    }
}

export function getDocumentScrollHeight(): number {
    return getScrollingElement().scrollHeight;
}

function getScrollingElement(): Element {
    return document.scrollingElement || document.body;
}

export function getElementScrollHeight(element: HTMLElement): number {
    return element && element.scrollHeight;
}

export function getElementScrollTop(element: HTMLElement): number {
    return element && element.scrollTop;
}

export function getElementOffsetHeight(element: HTMLElement): number {
    return element && element.offsetHeight;
}
